import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import Configs from "../../vendorConfigs/Configs";

export default class HasFreeGamesRequest implements IRequestBuilder {
    get method() {
        return "GET";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/ping";
    }
  
    get requestData() {
        return {
            sid: GameModel.sessionID,
            g: Configs.vendorServer.gameId,
            ga: "deal", // gameAction
            expectFreeRounds: true,
        };
    }
}